import React, { useState } from 'react';
import axios from 'axios';
import './Spell.css';

const Spell = () => {
  const [word, setWord] = useState('');
  const [meaning, setMeaning] = useState('');
  const [antonyms, setAntonyms] = useState([]);
  const [plurals, setPlurals] = useState([]);
  const [error, setError] = useState('');

  const fetchWordDetails = async () => {
    try {
      const response = await axios.get(`https://api.dictionaryapi.dev/api/v2/entries/en/${word}`);
      const wordData = response.data[0];

      setMeaning(wordData.meanings[0].definitions[0].definition);
      setAntonyms(wordData.meanings[0].definitions[0].antonyms || []);
      setPlurals(wordData.meanings[0].definitions[0].synonyms || []);
      setError('');
    } catch (err) {
      setError('Word not found');
      setMeaning('');
      setAntonyms([]);
      setPlurals([]);
    }
  };

  const speakText = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    window.speechSynthesis.speak(utterance);
  };

  const handleClear = () => {
    setWord('');
    setMeaning('');
    setAntonyms([]);
    setPlurals([]);
    setError('');
  };

  return (
    <div className="AppSpell">
      <h1>Find out here Word Meaning, Listen meaning and read word</h1>
      <input
        type="text"
        value={word}
        onChange={(e) => setWord(e.target.value)}
        placeholder="Enter a word"
      />
      <div className="buttons">
        <button onClick={fetchWordDetails}>Display Meaning</button>
        <button onClick={() => speakText(word)}>Speak Word</button>
        <button onClick={() => speakText(meaning)}>Read Meaning</button>
        {/* <button onClick={() => speakText(antonyms.join(', '))}>Antonyms</button>
        <button onClick={() => speakText(plurals.join(', '))}>Plurals</button> */}
        <button onClick={handleClear}>Clear</button>
      </div>
      {error && <p className="error">{error}</p>}
      {meaning && (
        <div className="meaning">
          <h2>Meaning:</h2>
          <p>{meaning}</p>
        </div>
      )}
      {antonyms.length > 0 && (
        <div className="antonyms">
          <h2>Antonyms:</h2>
          <p>{antonyms.join(', ')}</p>
        </div>
      )}
      {plurals.length > 0 && (
        <div className="plurals">
          <h2>Plurals:</h2>
          <p>{plurals.join(', ')}</p>
        </div>
      )}
    </div>
  );
};

export default Spell;